module.exports = __webpack_public_path__ + "img/star6.2b818907.png";